// const productInfo = document.querySelector('variant-picker')
// function updatePlansUnique() {
//   const target = document.querySelector('variant-picker')
//   if (!target) return

//   const checkedInput = target.querySelector('input[type="radio"]:checked')
//   if (!checkedInput) return

//   const servingPriceEl = checkedInput.closest('li')?.querySelector('.serving-price')
//   if (!servingPriceEl) return

//   const discountPrice = servingPriceEl.getAttribute('data-discount-price') || ""
//   const originalPrice = servingPriceEl.getAttribute('data-orignal-price') || ""

//   const subscPlan = document.querySelectorAll('.subscription-plan-serving .serv-price')
//   if (subscPlan.length > 0) {
//     subscPlan.forEach(sub => {
//       sub.textContent = discountPrice
//     });
//   }
//   // const oneTimeContainer = document.querySelector('.loop-widget-purchase-option-onetime')
//   // if (oneTimeContainer) {
//   //   oneTimeContainer.querySelectorAll('.onetime-plan-serving').forEach(el => el.remove())
//   //   const block = document.createElement('div')
//   //   block.className = 'onetime-plan-serving'
//   //   block.innerHTML = `
//   //     <span>30 servings shipped once</span>
//   //     <span><span class="serv-price">${originalPrice}</span> / serving</span>
//   //   `
//   //   oneTimeContainer.appendChild(block)
//   // }
//   const customOtp = document.querySelector('.custom-subscription')
//   if (customOtp) {
//     customOtp.querySelectorAll('.onetime-plan-serving').forEach(el => el.remove())
//     const block = document.createElement('div')
//     block.className = 'onetime-plan-serving'
//     block.innerHTML = `
//       <span>30 servings shipped once</span>
//       <span><span class="serv-price">${originalPrice}</span> / serving</span>
//     `
//     customOtp.appendChild(block)
//   }
// }

// document.addEventListener('DOMContentLoaded', function() {
//   updatePlansUnique()
// })
document.addEventListener('DOMContentLoaded', function() {
  const cs_flex_subtext = document.querySelector('.ultimate-essentials .heading.subtext-lg')
  if (cs_flex_subtext) {
    const cs_flex1 = cs_flex_subtext.closest('.cs_flex')
    const sliderElement = cs_flex1?.querySelector('slider-element')
    if (sliderElement) {
      sliderElement.insertAdjacentElement('afterbegin', cs_flex_subtext)
    }
  }
  const btmNotePara = document.querySelector('.btm-note .rte p')
  const ultimateText = document.querySelector('.ultimate-essentials-btm-text')

  if (btmNotePara && ultimateText) {
    ultimateText.appendChild(btmNotePara)
  }

  if(window.innerWidth < 768) {
    const cs_flex_btn = document.querySelector('.ultimate-essentials .button')
    if (cs_flex_btn) {
      const cs_flex = cs_flex_btn.closest('.cs_flex')
      if (cs_flex) cs_flex.appendChild(cs_flex_btn)
    }
    const cs_flex_btn1 = document.querySelector('.custom-testimonials-reviews .button')
    if (cs_flex_btn1) {
      const cs_flexx = cs_flex_btn1.closest('.cs_flex')
      if (cs_flexx) cs_flexx.appendChild(cs_flex_btn1)
    }
  }

})

const moveSections = document.querySelectorAll('[class*="move__"]')

moveSections.forEach(sectionEl => {
  const sectionClasses = sectionEl.className.split(' ')
  const moveClassName = sectionClasses.find(cls => cls.startsWith('move__'))
  if(moveClassName){
    const targetClassName = moveClassName.split('move__')[1]
    const targetEl = document.querySelector(`.${targetClassName}`)
    if(targetEl) targetEl.appendChild(sectionEl)
  }
})


const fixedImg = document.querySelector(".fixed-icon .group-block__content");
const fixedAllImg = document.querySelectorAll(".fixed-icon .group-block__content > div");
const sachet = document.querySelector(".sachet-img");
const loamWrap = document.querySelector(".loam-btm-wrap img");
const grandWrap = document.querySelector(".grand-text-wrap");

if (fixedImg && sachet && loamWrap && fixedAllImg.length > 0 && grandWrap) {
  let currentIndex = 0;
  fixedAllImg[currentIndex].classList.add("active");

  const maxScale = 1;
  const minScale = 0;
  const distanceToFullScale = 500;
  const distanceToFullScale1 = 150;
  const distanceToFullScale2 = 40;
  const changeDistance = 120; // scroll distance for image change

  // starting scroll point jab grandWrap top touch kare
  let startScroll = null;

  window.addEventListener("scroll", () => {
    const sachetTop = sachet.getBoundingClientRect().top;
    const loamTop = loamWrap.getBoundingClientRect().top;
    const grandWrapTop = grandWrap.getBoundingClientRect().top;

    let progress = 0;

    if (window.innerWidth < 768) {
      // console.log("sachet",sachetTop.toFixed(2))
      // console.log("loam",loamTop.toFixed(4))
      if (sachetTop <= 70 && loamTop > 120) {
        const scrolled = Math.min(Math.abs(sachetTop - 70), distanceToFullScale);
        progress = scrolled / distanceToFullScale;
      }
      if (loamTop <= 120) {
        const scrolledBack = Math.min(Math.abs(loamTop - 120), distanceToFullScale2);
        progress = 1 - scrolledBack / distanceToFullScale2;
      }
    } else {
      if (sachetTop <= 150 && loamTop > 150) {
        const scrolled = Math.min(Math.abs(sachetTop - 150), distanceToFullScale);
        progress = scrolled / distanceToFullScale;
      }
      if (loamTop <= 150) {
        const scrolledBack = Math.min(Math.abs(loamTop - 150), distanceToFullScale1);
        progress = 1 - scrolledBack / distanceToFullScale1;
      }
    }

    progress = Math.min(Math.max(progress, 0), 1);
    const scale = minScale + (maxScale - minScale) * progress;

    fixedImg.style.opacity = progress;
    fixedImg.style.transform = `scale(${scale})`;

    // --- image switching only after grandWrap top touch ---
    // console.log(loamTop.toFixed(4))

    let varHeight, diff
    if (window.innerWidth <= 768) { 
      varHeight = 500
      diff = 110
    } else {
      varHeight = 1600
      diff = 420
    }
    let totalImg = fixedAllImg.length
    fixedAllImg.forEach(img => img.classList.remove('active'))
    for (let i = 0; i < totalImg; i++) {
      let upper = varHeight - (diff * i)
      let lower = varHeight - (diff * (i + 1))
      if (loamTop <= upper && loamTop > lower) {
        fixedAllImg[i + 1] && fixedAllImg[i + 1].classList.add('active')
        return
      }
    }
    fixedAllImg[0].classList.add('active')
  });
}



// ---- sachet rotation (start when sachet bottom hits window bottom) ----
if (sachet) {
  const sachetDistance = 200; // adjust scroll distance for full rotation

  window.addEventListener("scroll", () => {
    const sachetRect = sachet.getBoundingClientRect();
    const sachetBottom = sachetRect.bottom;
    const windowHeight = window.innerHeight;

    // mobile vs desktop rotation
    const sachetMaxRotate = window.innerWidth < 768 ? 15 : 10;

    let sachetProgress = 0;
    if (sachetBottom <= windowHeight) {
      // start rotate when sachet bottom reaches viewport bottom
      const scrolled = Math.min(windowHeight - sachetBottom, sachetDistance);
      sachetProgress = scrolled / sachetDistance; // 0 → 1
    }

    sachetProgress = Math.min(Math.max(sachetProgress, 0), 1);
    const sachetRotate = sachetMaxRotate * sachetProgress;
    sachet.style.transform = `rotate(${sachetRotate}deg)`;
  });
}



document.addEventListener('scroll', () => {
  const declineSection = document.querySelector('.decline-wrap .third-content');
  const stickyTarget = document.querySelector('.left-sticky .group-block__content > div:last-child');
  if (!declineSection || !stickyTarget) return;

  const sectionRect = declineSection.getBoundingClientRect();
  const targetRect = stickyTarget.getBoundingClientRect();

  // progress start: section top == stickyTarget bottom
  const start = targetRect.bottom;
  // progress end: section top == stickyTarget top
  const end = targetRect.top;

  // normalize progress
  let scrollProgress = (start - sectionRect.top) / (start - end);
  scrollProgress = Math.min(Math.max(scrollProgress, 0), 1);

  const clipPercent = scrollProgress * 100;
  stickyTarget.style.clipPath = `inset(0 0 ${clipPercent}% 0)`;
});




document.addEventListener('DOMContentLoaded', () => {
  const tabs = document.querySelectorAll('.decline-wrap .tab-names h4');
  const contents = document.querySelectorAll('.decline-wrap .tab-content');
  if (tabs.length === 0 || contents.length === 0) return;
  tabs[0].classList.add('active');
  contents[0].classList.add('active');
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', function () {
      tabs.forEach(t => t.classList.remove('active'));
      contents.forEach(c => c.classList.remove('active'));
      if (contents[index]) {
        contents[index].classList.add('active');
        this.classList.add('active');
      }
    });
  });
});


document.querySelectorAll('a[href="#mitophagy"]').forEach(el => {
  el.addEventListener('click', e => {
    e.preventDefault();
    const slide = document.querySelector('.healthy-slide');
    if (slide) slide.classList.add('active');
    document.body.style.overflow = 'hidden';
  });
});

document.querySelectorAll('a[href="#mitophagy-close"], .healthy-slide .overlay').forEach(el => {
  el.addEventListener('click', e => {
    e.preventDefault();
    const slide = document.querySelector('.healthy-slide');
    if (slide) slide.classList.remove('active');
    document.body.style.overflow = '';
  });
});





const spots = document.querySelectorAll('.spot-wrap .spot')
const spotMain = document.querySelector('.spot-main')
const plusIcons = document.querySelectorAll('.spot-image .plus-icon')
const subheadings = document.querySelectorAll('.hotspot-bedrock .spot-wrap .spot .banner__subheading')

// plus-icon click logic
if (plusIcons.length && spots.length && spotMain) {
  plusIcons.forEach((btn, i) => {
    const target = document.querySelector(`.spot-wrap .spot-${i + 1}`)
    if (!target) return

    // tooltip create
    let tooltip = btn.querySelector('.tooltip-text')
    if (!tooltip) {
      tooltip = document.createElement('span')
      tooltip.className = 'tooltip-text'
      btn.appendChild(tooltip)
    }

    btn.addEventListener('click', () => {
      // sab remove
      spots.forEach(spot => spot.classList.remove('active'))
      plusIcons.forEach(icon => icon.classList.remove('active'))

      // desktop par hi remove hoga spotMain
      if (window.innerWidth >= 768) {
        spotMain.classList.remove('active')
      }

      // add active
      target.classList.add('active')
      btn.classList.add('active')

      // text inject
      const title = target.querySelector('h3')
      tooltip.textContent = title ? title.textContent.trim() : ''

      // tooltip side detect
      const btnRect = btn.getBoundingClientRect()
      const screenWidth = window.innerWidth
      if (btnRect.left > screenWidth / 2) {
        tooltip.classList.add('left')
        tooltip.classList.remove('right')
      } else {
        tooltip.classList.add('right')
        tooltip.classList.remove('left')
      }
    })
  })
}

// subheading click logic
if (subheadings.length && spots.length && spotMain) {
  subheadings.forEach((el, i) => {
    el.addEventListener('click', () => {
      spots.forEach(spot => spot.classList.remove('active'))
      plusIcons.forEach(icon => icon.classList.remove('active'))
      if (window.innerWidth < 768) {
        // // mobile: spotMain hamesha active
        // spotMain.classList.add('active')
        // const target = document.querySelector(`.spot-wrap .spot-${i + 1}`)
        // if (target) {
        //   target.classList.add('active')
        //   plusIcons[i]?.classList.add('active')
        // }
      } else {
        // desktop
        spotMain.classList.remove('active')
        spotMain.classList.add('active')
      }
    })
  })
}

// subheading text se plus-icon positioning
if (subheadings.length && plusIcons.length) {
  subheadings.forEach((sub, i) => {
    const text = sub.textContent.trim()
    if (!text.includes('|')) return
    const [top, left] = text.split('|').map(val => val.trim())
    if (plusIcons[i]) {
      plusIcons[i].style.opacity = 1
      plusIcons[i].style.position = 'absolute'
      plusIcons[i].style.top = `${top}%`
      plusIcons[i].style.left = `${left}%`
    }
  })
}

document.addEventListener('DOMContentLoaded', () => {
  function toggleRecommendations(cart) {
    if (!cart || !cart.items) return;
    setTimeout(() => {
      const hasSubscription = cart.items.some(item => item.selling_plan_allocation);
      const recommendations = document.querySelector('.drawer__content product-recommendations');
      if (recommendations) {
        recommendations.style.display = hasSubscription ? 'none' : 'block';
      }
    }, 200);
  }
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => toggleRecommendations(cart))
    .catch(err => console.error('cart fetch error', err));
  if (window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS && theme.pubsub.PUB_SUB_EVENTS.cartUpdate) {
    theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, (event) => {
      console.log('cart update');
      toggleRecommendations(event.cart);
    });
  }
});



function addToCartAndUpdateDrawer(productId, quantity = 1) {
  let formData = {
    'items': [{
      'id': productId,
      'quantity': quantity
    }]
  };

  // sectionsToRender me cart-drawer ka section id pass karo
  const sectionsToRender = ['sections--24274482757666__cart-drawer'];

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => response.json())
  .then(() => {
    const body = JSON.stringify({ sections: sectionsToRender });
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body
    });
  })
  .then(res => res.json())
  .then(parsedState => {
    if (window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS) {
      theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { 
        source: 'custom-add',
        cart: parsedState,
        open: true
      });
    } else {
      console.warn('theme pubsub not found');
    }
  })
  .catch(error => console.error('Error:', error));
}

document.addEventListener("DOMContentLoaded", function() {
  const dropdown = document.querySelector(".purchase-dropdown");
  const selected = dropdown?.querySelector(".purchase-selected");
  const selectedTitle = selected?.querySelector(".plan-title");
  const list = dropdown?.querySelector(".purchase-list");
  const input = dropdown?.querySelector("#purchaseType");

  if(!window.location.href.includes('product')) return

  // function: set selected option
  function setSelectedOption(value, text) {
    list.querySelectorAll("li").forEach(li => li.classList.remove("active"));
    const match = list.querySelector(`[data-value="${value}"]`);
    if (match) match.classList.add("active");
    selectedTitle.textContent = text.trim();
    input.value = value;
  }

  // check which option is active in main section on load
  function detectActiveOption() {
    const oneTimeActive = document.querySelector("[data-loop-widget-purchase-option].loop-widget-purchase-option-selected");
    const activePlan = document.querySelector("[data-selling-plan-group-id].loop-widget-purchase-option-selected");

    if (oneTimeActive) {
      const oneTimeLi = list.querySelector('[data-value="onetime"]');
      if (oneTimeLi) setSelectedOption("onetime", oneTimeLi.textContent);
    } else if (activePlan) {
      const activeId = activePlan.getAttribute("data-selling-plan-group-id");
      const planLi = list.querySelector(`[data-value="${activeId}"]`);
      if (planLi) setSelectedOption(activeId, planLi.textContent);
    } else {
      // default fallback
      const firstLi = list.querySelector("li");
      if (firstLi) setSelectedOption(firstLi.dataset.value, firstLi.textContent);
    }
  }

  // call it on page load
  detectActiveOption();

  // toggle dropdown
  selected.addEventListener("click", (e) => {
    e.stopPropagation();
    dropdown.classList.toggle("open");
  });

  // handle list click
  list.querySelectorAll("li").forEach(item => {
    item.addEventListener("click", (e) => {
      e.stopPropagation();

      setSelectedOption(item.dataset.value, item.textContent);
      dropdown.classList.remove("open");

      // trigger click in main section
      if (item.dataset.value === "onetime") {
        const oneTimeOption = document.querySelector("[data-loop-widget-onetime-purchase-option]");
        if (oneTimeOption) oneTimeOption.click();
      } else {
        const planOption = document.querySelector(`[data-selling-plan-group-id="${item.dataset.value}"]`);
        if (planOption) planOption.click();
      }
    });
  });

  // close dropdown when clicked outside
  document.addEventListener("click", (e) => {
    if (!dropdown.contains(e.target)) dropdown.classList.remove("open");
  });


  


});



const logoImg = document.querySelector('.loam-btm-wrap img');
let prevScrollY = window.scrollY;
let currentSkew = 0;
let isRafRunning = false;

function applySkewEffect() {
  const newScrollY = window.scrollY;
  const scrollDelta = newScrollY - prevScrollY;

  // Limit max skew to ±6 degrees
  currentSkew += scrollDelta * 0.15;
  currentSkew = Math.max(Math.min(currentSkew, 6), -6);

  logoImg.style.transform = `skewX(${currentSkew}deg)`;

  // Smoothly return to neutral
  currentSkew *= 0.8;

  prevScrollY = newScrollY;
  isRafRunning = false;
}

window.addEventListener('scroll', () => {
  if (!isRafRunning) {
    if (logoImg) {
      window.requestAnimationFrame(applySkewEffect);
      isRafRunning = true;
    }
  }
});



